import {Injectable} from '@angular/core';
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/compat/firestore';
import {Observable} from 'rxjs';
import {Ordered} from '../models/ordered';

@Injectable({
  providedIn: 'root'
})
export class TransferService {

  constructor (
    private db: AngularFirestore,
  ) { }

  loadTransfers (product_id: any) {

    return this.db.collection<any>('sbccv_orders', ref => ref
      .where('product_id', '==', product_id)
      .where('returnCode', '==', 'transfer')
      .orderBy('date', 'desc')).snapshotChanges()

  }

  updateTransfer (id: string, waiting: boolean, allowed: boolean) {
    return this.db.collection('sbccv_orders').doc(id).set({
      'waiting': waiting,
      'allowed': allowed,
    }, {'merge': true});
  }

  itemDoc: AngularFirestoreDocument<Ordered>;
  item: Observable<Ordered>;

  cancelTransfer (id: string) {

    return this.db.doc<Ordered>('sbccv_orders/' + id).get()
      .subscribe((result: any) => {

        if (result.data().eventSlots) {

          //cancela a transferencia
          return this.db.collection('sbccv_orders').doc(id).set({
            'waiting': false,
            'allowed': false,
            'returnCode': 'transfer_canceled',
          }, {'merge': true})
            .then(() => {

              //atualiza cada event_slot
              result.data().eventSlots.forEach(slot_id => {
                this.db.doc<Ordered>('sbccv_event_slots/' + slot_id)
                  .get()
                  .subscribe((slots: any) => {

                //decrementando de 1 a quantidade usada
                    var qtd_used = (slots.data().slot_used - 1)

                    return this.db.collection('sbccv_event_slots').doc(slot_id).set({
                      'slot_used': qtd_used,
                    }, {'merge': true})

                  })

              });

            })

        }

      })

  }

  makeMsgError (errorsCode) {
    let msgError: string

    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }
    return msgError
  }

}

